import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_022.jpg';
page.images = [
  {
    imageId: 'page022_zoom0',
    rectangle: {
      x: 138,
      y: 434,
      width: 1633,
      height: 1850,
    },
    imageSrc: 'images/page022/022.jpg',
  },
];
page.paint = [
  {
    id: 'page011_game1',
    icon: 'ikona_cw1',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Pomóż myszce odnaleźć ser.  ',
      audio: 'files/page011/z11c1.mp3',
      item: {
        path: 'informatyka/files/page011/z.11cw.1.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page011_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Uzupełnij kolorami puste pola.  ',
      audio: 'files/page011/z11c2.mp3',
      item: {
        path: 'informatyka/files/page011/z.11cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
];
page.games = [
  {
    id: 'page011_game3',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
export default page;
